import React from 'react';
import FinancialStatement1 from '../../../assets/img/award/financial-statement-1.png';
import FinancialStatement2 from '../../../assets/img/award/financial-statement-2.png';
import SampleImagePage from './sample-image-page';

const styles = {
  card: 'w-[60%] self-stretch px-10 pt-2 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-brand-cyan inline-flex flex-col justify-start items-start',
  title: 'justify-start text-blue text-3xl font-normal font-serif leading-8',
  introSection: 'self-stretch text-xl',
  introSectionTitle: 'text-xl mb-2',
};

const SampleFinancialStatement = () => {
  return (
    <SampleImagePage
      cardClassName={styles.card}
      titleClassName={styles.title}
      sectionClassName={styles.introSection}
      sectionTitleClassName={styles.introSectionTitle}
      items={[
        { title: 'Sample One', src: FinancialStatement1, alt: 'Financial Statement Sample 1', width: '100%', imageStyle: { marginBottom: '0.6rem' } },
        {
          title: 'Sample Two',
          src: FinancialStatement2,
          alt: 'Financial Statement Sample 2',
          width: '100%',
          imageStyle: { outline: '1.5px solid #D1D5DB', outlineOffset: '-0.2px', marginBottom: '0.6rem' },
        },
      ]}
    />
  );
};

export default SampleFinancialStatement;
